import Vue from "vue";
import App from "./App.vue";
import "./libs/number-utils";
import router from "./router";
import store from "./store";
import config from "./config";
import service from "./api-service";
import axios from '@/api-service/axios'
import Vant from 'vant';
import { Toast } from 'vant';
import VConsole from 'vconsole';
import VueCookies from 'vue-cookies';
import VueInfiniteScroll from 'vue-infinite-scroll';
import VueMeta from 'vue-meta';
import VueUtils from '@/libs/vue-utils';
import filters from './filter';
import { buildCityList } from '@/libs/map-utils'
import { Lazyload } from 'vant';
import 'vant/lib/index.css';
import "lib-flexible";

import { dateFormatter, getCalendar, test } from '@/libs/date-utils';

import { getPlatform, formatDistance } from '@/libs/common-utils/common-utils';


Vue.config.productionTip = false;

Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(VueCookies);
Vue.use(VueInfiniteScroll);
Vue.use(VueUtils);
Vue.use(filters);
Vue.use(VueMeta);

if (store.getters.env_mode && store.getters.env_mode == 'test') {
    Vue.use(new VConsole());
}

Vue.prototype.$config = config;
Vue.prototype.$service = service;

Toast.setDefaultOptions('loading', { duration: 0, forbidClick: true });

initializtionProgram();

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");

/**
 * 初始化工作 配置渠道入口
 */
function initializtionProgram() {
    let platform = getPlatform();
    store.commit('setPlatformType', platform);
    // 1482FF
    const auth_code = decodeURIComponent((new RegExp('[?|&]' + 'auth_code' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null

    // console.log(`初始化工作 -> 获取参数partnerkey - ${partnerkey}, mobile - ${mobile}, citycode - ${citycode}, du_sign - ${du_sign}, tms - ${tms}, poi - ${poi}, flag - ${flag}`);

    if (auth_code) {
        store.commit('setAuthCode', auth_code);
    }
    //刷新Cookie
    store.getters.authCode ? store.commit('setAuthCode', store.getters.authCode) : void(0);
    store.getters.loginPhone ? store.commit('setLoginPhone', store.getters.loginPhone) : void(0);
    store.getters.openId ? store.commit('setOpenId', store.getters.openId) : void(0);

}
